import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import { AppTheme } from '../styles/AppTheme';

export function StatusTile(props) {
  const keyData = props.keyData
  const item = props.item
  return (
    <Grid item key={'stats' + keyData} lg={props.tileSize ? props.tileSize : 2} xs={6} sm={4} md={4} gap={2} className={css(Styles.outerTileContainer,props.outerTileContainer)}>
      <div className={props.disableNav ? css(Styles.outerContainer, Styles.disableContainer, props.outerContainer) : css(Styles.outerContainer,props.outerContainer)}>
        <div className={css(Styles.innerContainer)}>
          {item.icon && (
            <div className={css(Styles.imgContainer,props.iconContainer)}>
              <i className='material-icons-outlined' style={{ fontSize: 18, padding: 5 }}>{item.icon}</i>
            </div>
          )}
          <div>
            <div className={css(Styles.title,props.title)}>{item.title}</div>
          </div>
        </div>
        {item.value && <div className={css(Styles.value,props.valueStyle)}>{item.value ? item.value : '-'}</div> }
        {item.valueIcon && <div className={css(Styles.value, props.valueIcon)}>
          <i className={css(Styles.value,props.valueStyle) + ' material-icons-outlined'} style={{ fontSize: 60, padding: 5 }}>{item.valueIcon}</i>
        </div>
        }
      </div>
    </Grid>
  )
}

const Styles = StyleSheet.create({
  outerTileContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  outerContainer: {
    border: 'solid 1px lightgray',
    padding: '10px 20px 10px',
    borderRadius: AppTheme.borderRadius,
    flex: 1,
    // cursor: 'pointer',
    '@media (max-width: 767px)': {
      padding: '20px 10px',
      borderRadius: 8,
    }
  },
  disableContainer: {
    cursor: 'unset'
  },
  innerContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: AppTheme.appFontColor,
    fontSize: AppTheme.appFontSize,
    margin: AppTheme.pMargin
  },
  value: {
    color: AppTheme.appFontColor,
    fontSize: 50,
    margin: 0
  },
})


// WEBPACK FOOTER //
// ./src/components/StatusTile.js